import Typography from "@mui/material/Typography";
import style from "./Explore_3.module.css";
import PageButton from "../../components/PageButton";

function Explore_3_2() {
  return (
    <div style={{ height: "100%" }}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          height: "calc(100vh - 100px)",
        }}
      >
        <div>
          <Typography className={style.wordsbox}>
            “ Entrepreneurship is a management process
            <br />
            that pursues opportunity without regard to
            <br />
            resources currently controlled.”
            <br />
            「創業家精神是一個追求有方法、有步驟的管理過程。
            <br />
            只要看見機會，便不受現有的資源限制，
            <br />
            嘗試找出能夠突破的方法，並確實抓住這個機會。」
          </Typography>
        </div>
      </div>
      <div className={style.pageBtn}>
        <PageButton passPath={"/explore-4"} nextPath={"/explore-3-3"} />
      </div>
    </div>
  );
}

export default Explore_3_2;
